import AddEvaluationGradeEntryLoader from './Loaders/AddEvaluationGradeEntryLoader';
import AddEvaluationGradeEntry from './parts/AddEvaluationGrade/AddEvaluationGradeEntry';
import { useParams } from 'react-router';

export const GradeEntryAddEvaluationGrades = () => {
  const { id } = useParams<{ id: string }>();

  return (
    <AddEvaluationGradeEntryLoader sectionId={id}>
      <AddEvaluationGradeEntry />
    </AddEvaluationGradeEntryLoader>
  );
};
